import { all, fork, takeEvery, takeLatest } from 'typed-redux-saga';

import { setPeersTab, setSidebarContent } from '../../sidebar/slice';
import { admitAllWaitingRoomPeersAction, admitWaitingRoomPeerAction, showWaitingRoomSidebarAction } from '../slice';
import { admitAllWaitingRoomPeersSaga } from './admit-all';
import { admitWaitingRoomPeerSaga } from './admit-one';
import { watchWaitingRoomAccessPollingSaga } from './check-access';
import { watchWaitingRoomPollingSaga } from './peers';
import {
    resetHasNewWaitingRoomPeersSaga,
    showWaitingRoomSidebarSaga,
    watchParticipantsAndShowNotifications,
} from './ui-effects';

export function* waitingRoomsSaga() {
    yield all([
        takeEvery(admitWaitingRoomPeerAction.type, admitWaitingRoomPeerSaga),
        takeEvery(admitAllWaitingRoomPeersAction.type, admitAllWaitingRoomPeersSaga),
        takeEvery(showWaitingRoomSidebarAction.type, showWaitingRoomSidebarSaga),
        fork(watchParticipantsAndShowNotifications),
        fork(watchWaitingRoomPollingSaga),
        fork(watchWaitingRoomAccessPollingSaga),
        takeLatest(setPeersTab.type, resetHasNewWaitingRoomPeersSaga),
        takeLatest(setSidebarContent.type, resetHasNewWaitingRoomPeersSaga),
    ]);
}
